__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/0fd6d70/_next/";